'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.state = { isHovering: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var color = this.state.isHovering && this.props.hoverColor ? this.props.hoverColor : this.props.color;
      return _react2.default.createElement(
        'span',
        { onMouseOut: this.onMouseOut.bind(this), onMouseOver: this.onMouseOver.bind(this) },
        _react2.default.createElement(
          'svg',
          { viewBox: '0 2 12 15', width: '100%', height: '100%' },
          _react2.default.createElement('path', { fill: color, d: 'M12 14.5h-.102C11.419 15.917 8.97 16.999 6 16.999c-2.97 0-5.42-1.082-5.899-2.499H0v-9h.101A1.546 1.546 0 0 1 0 5c0-1.658 2.686-3 6-3 3.313 0 6 1.342 6 3 0 .171-.046.337-.102.5H12v9zM6 2.998c-2.762 0-5 .896-5 2.001 0 1.104 2.238 2 5 2s5-.896 5-2c0-1.105-2.238-2.001-5-2.001zm5 3.655c-1.074.81-2.91 1.345-5 1.345s-3.926-.535-5-1.345v1.346c0 1.104 2.238 2 5 2 2.761 0 4.999-.896 5-2V6.653zm0 3c-1.074.81-2.91 1.345-5 1.345s-3.926-.535-5-1.345v1.346c0 1.104 2.238 2 5 2 2.761 0 4.999-.896 5-2V9.653zm-5 4.346c-2.09 0-3.926-.535-5-1.345v1.345c0 1.105 2.238 2 5 2 2.761 0 4.999-.896 5-2v-1.345c-1.074.809-2.91 1.345-5 1.345z' })
        )
      );
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      this.setState({ isHovering: false });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({ isHovering: true });
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  color: _react.PropTypes.string.isRequired,
  hoverColor: _react.PropTypes.string
};
_class.displayName = 'Redshift';
exports.default = _class;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/build/react/Redshift.js
// module id = 1087
// module chunks = 0